<div class="flex">
    <p-button [disabled]="!items||!items.length" icon="pi pi-download" label="Export" (click)="exportExcel()" />
    <span *ngIf="items">Total Records: {{ items.length | number }}</span>
</div>
<p-table [value]="items" [columns]="columns" sortMode="multiple"
        [paginator]="true" [rows]="30" [globalFilterFields]="globalFilterFields"
        (onSort)="handleSort($event)"
        [loading]="isBusy"
        [scrollable]="true"
        scrollHeight="1000px">
    <ng-template pTemplate="header">
        <tr>
            <th *ngFor="let col of columns" [pSortableColumn]="col.field" 
                [ngStyle]="{'min-width': col.width + 'px'}"
                [ngClass]="{'align-right': col.align === 'right'}">
                {{ col.label }}
                <p-sortIcon [field]="col.field"></p-sortIcon>
            </th>
        </tr>
        <tr>
            <th *ngFor="let col of columns">
                <p-columnFilter 
                    *ngIf="col.filterType === 'text'"
                    [field]="col.field" 
                    placeholder="All"
                    [matchMode]="col.matchMode || 'startsWith'"
                    [type]="col.filterType || 'text'"
                    [showClearButton]="true"
                    [showMenu]="true">
                </p-columnFilter>
                <p-columnFilter *ngIf="col.filterType === 'select'" 
                    [field]="col.field" 
                    [matchMode]="'equals'"
                    [showMenu]="false">
                    <ng-template pTemplate="filter" let-options>
                            <p-multiSelect [options]="getColumnOptions(col.field)" [(ngModel)]="selectedValues[col.field]" 
                            (onChange)="filterBySelectedValues()" defaultLabel="Select" [style]="{width: '100%'}" 
                            [filter]="false" [showHeader]="false">
                            </p-multiSelect>
                    </ng-template>
                </p-columnFilter>
            </th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData>
        <tr *ngIf="items.length === 0">
            <td [attr.colspan]="columns.length" class="no-results">No results found</td>
        </tr>
        <tr>
            <td *ngFor="let col of columns">
                <ng-container *ngIf="col.filterType === 'select'">{{ rowData[col.field] === null ? 'None' : rowData[col.field]  }}</ng-container>
                <ng-container *ngIf="col.filterType === 'date'">{{ rowData[col.field] | date:'yyyy-MM-dd' }}</ng-container>
                <ng-container *ngIf="col.filterType === 'text'">{{ rowData[col.field] }}</ng-container>
            </td>
        </tr>
    </ng-template>
</p-table>